// @ts-nocheck

import React, { useEffect } from 'react';
import styled from 'styled-components';

import useLoadImage from '../../hooks/useLoadImage';

const Image = styled.img`
  width: 100%;
  height: auto;
`;

type Props = {
  className?: string;
  src?: string;
  onLoad?: () => void;
};

const ImageWithLoadCallback = ({ className, src, onLoad }: Props) => {
  const { loaded, error } = useLoadImage<{ loaded: boolean; error: boolean }>(src);
  useEffect(() => {
    if (src && loaded && onLoad) {
      onLoad();
    }
  }, [loaded, onLoad, src]);
  return !error && loaded ? <Image className={className} src={src} /> : null;
};

export default ImageWithLoadCallback;
